import { Injectable, Input } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
    @Input() test: boolean;

    constructor() {
        super();
        this.getAndInitTranslations();
    }

    getAndInitTranslations() {
        this.itemsPerPageLabel = 'Items per page';
        // this.nextPageLabel = 'test';
        // this.previousPageLabel = 'test';
        this.changes.next();
    }
}
